<template>
  <div class="acode_page">
    <div class="container">
      <div class="page_title">A码购</div>
      <div class="acode_nav flex_row_between_center">
        <div class="acode_nav_con flex_row_start_center pointer">
          <div :class="{ item: true, active: current_state == 1 }" @click="changeState(1)">
            {{ L['可使用'] }}
          </div>
          <div :class="{ item: true, active: current_state == 2 }" @click="changeState(2)">
            {{ L['已使用'] }}
          </div>
          <div :class="{ item: true, active: current_state == 3 }" @click="changeState(3)">
            {{ L['已过期'] }}
          </div>

        </div>
        <div class="search_con flex_row_start_center">
          <div class="search_incon flex_row_start_center">
            <el-input class="search_input" v-model="keyword" :placeholder="L['请输入A码兑换并使用']" clearable @clear="clear"></el-input>
            <div class="search pointer" @click="exchagneAcode()">{{ L['兑换'] }}</div>
          </div>
        </div>
      </div>

      <div class="acode_list">
        <div class="acode_item_box" v-for="item in acode_list.data" :key="item.acodeId">
          <div class="acode_item" :class="{acode_item_disabled:item.state !=  1}">
            <div class="acode_top">
              <div class="acode_img_box">
                <img :src="item.goodsImage" alt="">
              </div>
              <div class="acode_con">
                <div class="acode_title">{{item.productShortTitle}}</div>
                <div class="acode_model">{{item.specValues}}</div>
                <div class="acode_price_btn">
                  <div class="acode_price">¥{{item.acodePrice}}</div>
                  <div class="acode_btn" v-if="current_state == 1" @click="openUseModal(item)">去使用</div>
                  <div class="acode_btn" v-if="current_state == 2">已使用</div>
                  <div class="acode_btn" v-if="current_state == 3">已过期</div>
                </div>
              </div>
            </div>
            <div class="acode_extra">
              <div class="acode_extra_time">有效期截止：{{item.endTime}}</div>
              <div class="acode_extra_explain" @click="getRule(item.articleId)">
                <img src="@/assets/question_icon.png" alt="">
                <span>使用说明</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="empty" v-if="acode_list.data.length == 0">
        <img src="@/assets/acode_empty.png" alt="">
        <div>暂无数据哦</div>
      </div>

      <el-dialog :title="''" v-model="show_success" customClass="success_modal" :width="414" lock-sroll="false" center>
        <div class="success_box">
          <div class="success_img">
            <img src="@/assets/buy/success.png" alt="">
          </div>
          <div class="success_title">兑换成功</div>
          <div class="success_btn" @click="openUseModal(current_acode)">去使用</div>
        </div>
      </el-dialog>
      <el-dialog :title="''" v-model="show_use_acode" customClass="success_modal" :width="414" lock-sroll="false" center>
        <div class="use_acode_box">
          <div class="use_acode_title">提示</div>
          <div class="use_acode_con">该A码可兑换{{current_acode.purchaseQuantity}}件商品，已兑换{{current_acode.usedQuantity}}件，请输入本次要兑换的件数</div>
          <div class="use_acode_operate">
            <div class="use_acode_change_amount " :class="{disabled_amount:currentSpecNum==1}" @click="editNum('reduce')">-</div>
            <input class="use_acode_input" type="number" v-model="currentSpecNum" @input="editNum('edit', $event)" @blur="editNum('edit', $event)"
              cursor-spacing="0" :cursor="currentSpecNum.toString().length" maxlength="5" />
            <div class="use_acode_change_amount" :class="{disabled_amount:currentSpecNum>=(current_acode.purchaseQuantity - current_acode.usedQuantity)}"
              @click="editNum('add')">+</div>
          </div>
          <div class="use_acode_btn_box">
            <div class="use_acode_cancel" @click="cancelUseAcode()">取消</div>
            <div class="use_acode_confirm" @click="confirmUseAcode()">确定</div>
          </div>
        </div>
      </el-dialog>

      <el-dialog :title="''" v-model="show_rule_modal" customClass="rule_modal_dialog" :width="764" lock-sroll="false" center>
        <div class="rule_modal_box">
          <div class="rule_modal_title">{{rule_info.title||'使用说明'}}</div>
          <div class="rule_modal_T">

            <div class="rule_modal_con">
              <div class="rule_con" v-html="rule_info.content"></div>
            </div>
          </div>
        </div>
      </el-dialog>

    </div>
  </div>
</template>
<script>
import { reactive, getCurrentInstance, ref, onMounted, computed } from 'vue'
import {
  ElInput,
  ElMessage,
  ElMessageBox,
  ElTimeline,
  ElTimelineItem
} from 'element-plus'
import { useRouter, useRoute } from 'vue-router'
import { useStore } from 'vuex'
import SldCommonEmpty from '../../../components/SldCommonEmpty'

export default {
  components: {
    ElInput,
    ElTimeline,
    ElTimelineItem,
    SldCommonEmpty,
  },
  setup () {
    const store = useStore()
    const router = useRouter()
    const route = useRoute()
    const { proxy } = getCurrentInstance()
    const L = proxy.$getCurLanguage()
    const current_state = ref(1) //当前列表订单状态
    const keyword = ref('')

    const show_success = ref(false); // 兑换成功
    const show_use_acode = ref(false); // 使用acode
    const loading = ref(false)
    const show_rule_modal = ref(false); // 展示规则
    const rule_info = ref({});

    const current_acode = ref({})

    const currentSpecNum = ref(1); // 当前输入兑换数量

    const acode_list = reactive({ data: [] })
    const clear = () => {
      keyword.value = ""
    }
    const changeState = (state) => {
      console.log("state---->", state)
      if (loading.value) {
        return;
      }
      current_state.value = state;
      getAcodeList();
    }

    // 打卡去使用弹窗
    const openUseModal = (acodeItem) => {
      show_success.value = false

      current_acode.value = acodeItem;// 修改当前acode
      currentSpecNum.value = 1; // 重置 兑换数量
      // console.log("acodeItem---->", acodeItem)

      show_use_acode.value = true;
    }

    // 编辑兑换数量
    const editNum = (type, event) => {
      let reg = /\./g
      let reg0 = /0+\d/

      let limit = 99999999; // 单券可购买数量
      if (current_acode.value.purchaseQuantity) {
        limit = current_acode.value.purchaseQuantity - (current_acode.value.usedQuantity || 0);
      }

      if (reg.test(currentSpecNum.value.toString()) || currentSpecNum.value <= 0) {
        currentSpecNum.value = 1
      }

      // console.log("单券可购买数量——————————>", limit)

      if (type == 'add') {
        currentSpecNum.value++;
        if (currentSpecNum.value > limit) {
          currentSpecNum.value = limit
          ElMessage('已达到购买上限')
          return;
        }
      }
      if (type == 'reduce') {
        if (currentSpecNum.value > 1) {

          currentSpecNum.value--;
        } else {
          currentSpecNum.value = 1;
        }
      }
      if (type == 'edit') {
        if (currentSpecNum.value == '' || currentSpecNum.value < 0) {
          currentSpecNum.value = 1
          return
        }
        if (currentSpecNum.value > limit) {
          currentSpecNum.value = limit
          ElMessage('已达到购买上限')
          return;
        } else {
          currentSpecNum.value =
            e && e.detail.value ? e.detail.value : currentSpecNum.value
          if (currentSpecNum.value == 0 || currentSpecNum.value < 0) {
            currentSpecNum.value = 1
            return
          } else {
            currentSpecNum.value = currentSpecNum.value
              .toString()
              .replace(/\D/g, '')
            currentSpecNum.value = Number(currentSpecNum.value)

          }
        }
      }
    }

    const cancelUseAcode = () => {
      current_acode.value = {};
      currentSpecNum.value = 1;
      show_use_acode.value = false;
    };
    const confirmUseAcode = () => {
      show_use_acode.value = false;

      if (loading.value) {
        return;
      }
      loading.value = true;
      var param = {
        isCart: false,
        productId: current_acode.value.productId,
        productPrice: current_acode.value.acodePrice,
        number: currentSpecNum.value,
        source: 3,
      }



      let config = {
        headers: {
          "Content-Type": "application/json",
        },
      };
      proxy
        .$post('v3/business/front/orderOperate/check', param, config)
        .then(res => {
          if (res.state == 200) {
            loading.value = false

            console.log("校验库存---->", res.data)
            router.push({
              path: '/buy/confirm',
              query: {
                promotionType: 404,
                goodsId: current_acode.value.goodsId,
                productId: current_acode.value.productId,
                productPrice: current_acode.value.acodePrice,
                promotionCode: current_acode.value.code,
                ifcart: 0,
                numbers: currentSpecNum.value,
                promotionId: current_acode.value.acodeId,
              }
            })

          } else {
            loading.value = false
            ElMessage(res.msg)
          }
        })
        .catch(() => {
          //异常处理
        })
      loading.value = false;

      return

    };


    // 兑换A码
    const exchagneAcode = () => {
      if (!keyword.value) {
        return;
      }
      if (loading.value) {
        return;
      }
      loading.value = true;
      var param = {
        code: keyword.value
      }

      let config = {
        headers: {
          "Content-Type": "application/json",
        },
      };
      proxy
        .$post('v3/promotion/front/acode/exchange', param, config)
        .then(res => {
          if (res.state == 200) {
            loading.value = false

            current_acode.value = res.data;

            show_success.value = true; // 展示兑换成功
            current_state.value = 1;// 重置为可使用列表
            getAcodeList();
          } else {
            loading.value = false
            ElMessage(res.msg)
          }
        })
        .catch(() => {
          //异常处理
        })
      loading.value = false;
    }



    const getAcodeList = () => {
      if (loading.value) {
        return;
      }
      loading.value = true;
      var param = {
        "current": 1,
        "pageSize": 10000,
        "state": current_state.value,
      }

      let config = {
        headers: {
          "Content-Type": "application/json",
        },
      };
      proxy
        .$post('v3/promotion/front/acode/exchangeList', param, config)
        .then(res => {
          if (res.state == 200) {
            loading.value = false
            acode_list.data = res.data.list;
            console.log("res.data----->", res.data.list)

          } else {
            loading.value = false
            ElMessage(res.msg)
          }
        })
        .catch(() => {
          //异常处理
        })
      loading.value = false;
    }

    // 获取使用说明
    const getRule = (articleId) => {
      if (loading.value) {
        return;
      }
      loading.value = true;
      var param = { articleId: articleId };
      rule_info.value = {};
      show_rule_modal.value = true;

      proxy
        .$get('v3/cms/front/article/articleDetail', param)
        .then(res => {
          if (res.state == 200) {
            loading.value = false
            rule_info.value = res.data;

          } else {
            loading.value = false
            ElMessage(res.msg)
          }
        })
        .catch(() => {
          //异常处理
        })
      loading.value = false;
    }


    onMounted(() => {
      console.log("当前页----------> acode")
      getAcodeList();
    })

    return {
      L,
      current_state,
      keyword,
      clear,
      changeState,
      acode_list,
      exchagneAcode,
      show_success,
      openUseModal,
      show_use_acode,
      editNum,
      currentSpecNum,
      cancelUseAcode,
      confirmUseAcode,
      current_acode,
      show_rule_modal,
      getRule,
      rule_info,
    }
  },
}
</script>

<style lang="scss" scoped>
.acode_page {
  width: 1106px;
  margin-left: 10px;
  float: left;
  .container {
    padding: 0px;
    background-color: #fff;
    margin-bottom: 10px;
    .page_title {
      padding: 30px;
      font-weight: 500;
      font-size: 18px;
      color: #000000;
      line-height: 26px;
    }

    .acode_nav {
      .acode_nav_con {
        padding: 18px 30px;
        .item {
          padding: 0 15px;
          background: rgba(234, 237, 240, 0.4);
          font-family: Microsoft YaHei, Microsoft YaHei;
          font-weight: 400;
          font-size: 15px;
          color: #888e98;
          line-height: 28px;
          margin-right: 15px;
          position: relative;
        }
        .active {
          color: #ffffff;
          background: #000000;
        }

        .item_tag {
          position: absolute;
          background-color: red;
          color: #fff;
          top: -8px;
          right: -8px;
          height: 18px;
          display: flex;
          line-height: 19px;
          justify-content: center;
          border-radius: 18px;
          font-size: 12px;
          text-align: center;
          padding: 0 5px;
          font-weight: 500;
        }
      }
      .search_con {
        padding: 18px 30px;
        .search_input {
          ::v-deep .el-input__inner {
            height: 36px;
            border-radius: 0px;
          }
        }
        .search {
          flex-shrink: 0;
          width: 80px;
          height: 36px;
          text-align: center;
          background: #eaedf0;
          font-family: Microsoft YaHei, Microsoft YaHei;
          font-weight: 400;
          font-size: 12px;
          color: #000000;
          line-height: 36px;
        }
      }
    }
    .acode_list {
      padding: 30px;
      display: flex;
      flex-wrap: wrap;
      .acode_item_box {
        width: 480px;
        height: 197px;
        flex-shrink: 0;
        margin: 0 15px 15px 0;
      }

      .acode_item {
        width: 480px;
        height: 197px;
        background: #fff4f4;
        border-radius: 8px 8px 8px 8px;
        border: 1px solid #ffdbdb;
        cursor: default;
        .acode_top {
          height: 160px;
          border-bottom: 1px solid #ffdbdb;
          padding: 30px;
          padding-bottom: 25px;
          display: flex;
          .acode_img_box {
            flex-shrink: 0;
            display: flex;
            align-items: center;
            justify-content: center;
            width: 100px;
            height: 100px;
            border-radius: 0px 0px 0px 0px;
            border: 1px solid #eaedf0;
            overflow: hidden;
            > img {
              max-height: 100%;
              max-width: 100%;
            }
          }
          .acode_con {
            flex-grow: 1;
            padding-left: 20px;
            overflow: hidden;
            .acode_title {
              white-space: nowrap; /* 强制文本在一行内显示 */
              overflow: hidden; /* 超出部分隐藏 */
              text-overflow: ellipsis; /* 超出部分用省略号表示 */
              // width: 100%; /* 确保设置了宽度或者max-width */

              font-weight: 400;
              font-size: 15px;
              color: rgba(0, 0, 0, 0.7);
              line-height: 24px;
            }
            .acode_model {
              margin-top: 5px;
              font-weight: 400;
              font-size: 12px;
              color: #888e98;
              line-height: 16px;
            }

            .acode_price_btn {
              display: flex;
              align-items: center;
              justify-content: space-between;
              margin-top: 26px;
              .acode_price {
                font-weight: 400;
                font-size: 15px;
                color: #000000;
                line-height: 24px;
              }
              .acode_btn {
                width: 88px;
                height: 34px;
                background: linear-gradient(270deg, #e13535 0%, #ec7556 100%);
                border-radius: 2px;
                display: flex;
                align-items: center;
                justify-content: center;
                font-weight: 400;
                font-size: 15px;
                color: #ffffff;
                line-height: 22px;
              }
            }
          }
        }
        .acode_extra {
          height: 36px;
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding: 0 28px;

          font-weight: 400;
          font-size: 12px;
          color: #888e98;
          line-height: 16px;
          .acode_extra_time {
            position: relative;
          }
          .acode_extra_explain {
            position: relative;
            display: flex;
            align-items: center;
            > img {
              width: 16px;
              height: 16px;
              margin-right: 5px;
            }
          }
        }
      }
      .acode_item_disabled {
        border-color: #dedede;
        background: #f2f2f2;
        .acode_top {
          border-bottom: 1px solid #dedede;
          .acode_img_box {
            > img {
              opacity: 0.6;
            }
          }
          .acode_con {
            .acode_title {
              color: #888e98;
            }
            .acode_model {
              color: #888e98;
            }
            .acode_price_btn {
              .acode_price {
                color: #888e98;
              }
              .acode_btn {
                background: #bdbdbd;
              }
            }
          }
        }
        .acode_extra {
          color: #888e98;
        }
      }
    }
  }
}
.empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 120px 0 200px 0;
  > img {
    width: 120px;
    height: 120px;
    -webkit-user-drag: none;
    user-drag: none;
  }
  > div {
    margin-top: 15px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    font-size: 15px;
    color: #888e98;
    line-height: 24px;
  }
}

::v-deep .success_modal .el-dialog__header {
  padding: 0px;
}
::v-deep .success_modal .el-dialog__body {
  padding: 20px 40px;
}
.success_box {
  padding-top: 20px;
  cursor: default;
  .success_img {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 54px;
    height: 54px;
    margin: 0 auto;
    > img {
      -webkit-user-drag: none;
      user-drag: none;
      max-width: 100%;
      max-height: 100%;
    }
  }
  .success_title {
    text-align: center;
    margin: 20px 0 36px 0;
    font-weight: 500;
    font-size: 15px;
    color: #22253c;
    line-height: 24px;
  }
  .success_btn {
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 0 auto;
    width: 100px;
    height: 34px;
    background: #1e7cff;
    border-radius: 2px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    font-size: 15px;
    color: #ffffff;
    line-height: 24px;
  }
}

.use_acode_box {
  display: flex;
  flex-direction: column;
  .use_acode_title {
    font-weight: 500;
    font-size: 15px;
    color: #22253c;
    line-height: 24px;
    text-align: center;
  }
  .use_acode_con {
    font-weight: 400;
    font-size: 15px;
    color: #808080;
    line-height: 24px;
    text-align: center;
    margin: 10px 0;
  }
  .use_acode_operate {
    display: flex;
    justify-content: center;

    .use_acode_change_amount {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 40px;
      height: 40px;
      border: 1px solid #e0e0e0;
      font-size: 20px;
      color: rgba(0, 0, 0, 0.7);
      cursor: default;

      -moz-user-select: none; /*火狐*/

      -webkit-user-select: none; /*webkit浏览器*/

      -ms-user-select: none; /*IE10*/

      -khtml-user-select: none; /*早期浏览器*/

      user-select: none;
    }
    .use_acode_input {
      width: 60px;
      height: 40px;
      border: 1px solid #e0e0e0;
      border-left: none;
      border-right: none;
      font-weight: 500;
      font-size: 13px;
      color: rgba(0, 0, 0, 0.7);
      text-align: center;
    }
    .disabled_amount {
      color: rgba(0, 0, 0, 0.4);
    }

    /*** 消除input元素 type="number" 时默认的 加减按钮*/
    input[type="number"]::-webkit-inner-spin-button,
    input[type="number"]::-webkit-outer-spin-button {
      -webkit-appearance: none;
      margin: 0;
    }
    /*** 消除input元素 type="number" 时默认的 加减按钮---moz版*/
    input[type="number"] {
      -moz-appearance: textfield;
    }
  }
  .use_acode_btn_box {
    margin-top: 25px;
    display: flex;
    justify-content: center;
    cursor: default;
    > div {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 100px;
      height: 34px;
      border-radius: 2px;
      font-weight: 400;
      font-size: 15px;
      line-height: 24px;
    }
    .use_acode_cancel {
      border: 1px solid #e0e0e0;
      box-sizing: border-box;
      color: #888e98;
      margin-right: 20px;
    }
    .use_acode_confirm {
      background: #1e7cff;
      color: #ffffff;
    }
  }
}
::v-deep .rule_modal_dialog .el-dialog__header {
  padding: 0;
}
::v-deep .rule_modal_dialog .el-dialog__body {
  padding: 30px 0 0 0;
}
.rule_modal_box {
  position: relative;
  .rule_modal_title {
    font-family: Microsoft YaHei, Microsoft YaHei;
    font-weight: 500;
    font-size: 20px;
    color: #000000;
    line-height: 26px;
    text-align: center;
    padding: 20px 0 30px 0;
  }
  .rule_modal_T {
    height: 394px;
    padding-right: 2px;
  }
  .rule_modal_con {
    height: 394px;
    padding: 0 28px 30px 30px;
    overflow-y: overlay;
    &::-webkit-scrollbar {
      width: 4px !important;
    }
    &::-webkit-scrollbar-track {
      background-color: #fff;
    }

    &::-webkit-scrollbar-thumb {
      background: #e7e9eb; /* 滑块颜色 */
      border-radius: 10px; /* 圆角程度 */
    }
    .rule_con {
      min-height: 364px;
      background: #f9f9f9;
    }
  }
}
</style>